export default __webpack_public_path__ + "static/bashir-3a31341255024f36e8d936673bbc6976.png";